module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/2nFJec3VKk4GewOQECUW0-95ae5382b6e6b24e97135c84ee5d2915.jpg";